/* */ 
(function(Buffer, process) {
  'use strict';
  var http = require('npm:stream-http@2.3.0'),
      https = require('https'),
      ono = require('ono'),
      url = require('../util/url'),
      debug = require('../util/debug'),
      Promise = require('../util/promise');
  module.exports = {
    order: 200,
    headers: null,
    timeout: 5000,
    redirects: 5,
    withCredentials: false,
    canRead: function isHttp(file) {
      return url.isHttp(file.url);
    },
    read: function readHttp(file) {
      var u = url.parse(file.url);
      if (process.browser && !u.protocol) {
        u.protocol = url.parse(location.href).protocol;
      }
      return download(u, this);
    }
  };
  function download(u, httpOptions, redirects) {
    return new Promise(function(resolve, reject) {
      u = url.parse(u);
      redirects = redirects || [];
      redirects.push(u.href);
      get(u, httpOptions).then(function(res) {
        if (res.statusCode >= 400) {
          throw ono({status: res.statusCode}, 'HTTP ERROR %d', res.statusCode);
        } else if (res.statusCode >= 300) {
          if (redirects.length > httpOptions.redirects) {
            reject(ono({status: res.statusCode}, 'Error downloading %s. \nToo many redirects: \n  %s', redirects[0], redirects.join(' \n  ')));
          } else if (!res.headers.location) {
            throw ono({status: res.statusCode}, 'HTTP %d redirect with no location header', res.statusCode);
          } else {
            debug('HTTP %d redirect %s -> %s', res.statusCode, u.href, res.headers.location);
            var redirectTo = url.resolve(u, res.headers.location);
            download(redirectTo, httpOptions, redirects).then(resolve, reject);
          }
        } else {
          resolve(res.body || new Buffer(0));
        }
      }).catch(function(err) {
        reject(ono(err, 'Error downloading', u.href));
      });
    });
  }
  function get(u, httpOptions) {
    return new Promise(function(resolve, reject) {
      debug('GET', u.href);
      var protocol = u.protocol === 'https:' ? https : http;
      var req = protocol.get({
        hostname: u.hostname,
        port: u.port,
        path: u.path,
        auth: u.auth,
        headers: httpOptions.headers || {},
        withCredentials: httpOptions.withCredentials
      });
      if (typeof req.setTimeout === 'function') {
        req.setTimeout(httpOptions.timeout);
      }
      req.on('timeout', function() {
        req.abort();
      });
      req.on('error', reject);
      req.once('response', function(res) {
        res.body = new Buffer(0);
        res.on('data', function(data) {
          res.body = Buffer.concat([res.body, new Buffer(data)]);
        });
        res.on('error', reject);
        res.on('end', function() {
          resolve(res);
        });
      });
    });
  }
})(require('buffer').Buffer, require('process'));
